import CommodityModule from "@/pages/sy/catalogs/commodities";
import CommodityTypeModule from "@/pages/sy/catalogs/commodity-types";
import ChargeManagement from "@/pages/sy/charges-management";
import {
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  useTheme,
} from "@mui/material";
import {
  Category as CategoryIcon,
  CloudUpload as CloudUploadIcon,
  DescriptionOutlined as DescriptionIcon,
  LocalDrink as DrinkIcon,
  Person as PersonIcon,
  Build as ScienceIcon,
  Storage as StorageIcon,
  Timeline as TimelineIcon,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import CatalogMoldSize from "../pages/caster/catalogs/mold-sizes";
import CatalogMold from "../pages/caster/catalogs/molds";
import CatalogTundishShroud from "../pages/caster/catalogs/tundish-shrouds";
import CatalogTundish from "../pages/caster/catalogs/tundishes";
import CatalogCategories from "../pages/delays/categories";
import DelayCodePage from "../pages/delays/codes";
import CatalogElement from "../pages/laboratory/catalogs/elements";
import CatalogSampleType from "../pages/laboratory/catalogs/sampleType";
import CatalogOperator from "../pages/steel/catalogs/operators";
import CatalogBin from "../pages/steel/catalogs/bins";
import CatalogGrade from "../pages/steel/catalogs/grade";
import CatalogLadle from "../pages/steel/catalogs/ladle";
import CatalogMaterial from "../pages/steel/catalogs/materials";
import CatalogPourbackReason from "../pages/steel/catalogs/pourback-reasons";
import { ConfigurationsType } from "@dexteel/mesf-core/dist/configurationMenu";
import CatalogCrane from "@/pages/billets/catalogs/crane";
import CatalogLocation from "@/pages/billets/catalogs/locations";
import {
  CatalogRoofMetricLimits,
  CatalogSidewallMetricLimits,
  CatalogCasterMetricLimits,
} from "@/pages/eqp/shared/catalogs/metric-limits";

const components = [
  {
    path: "lab-elements/*",
    sidebar: () => <div>elements</div>,
    main: () => <CatalogElement />,
  },
  {
    path: "lab-sample-types/*",
    sidebar: () => <div>sample types</div>,
    main: () => <CatalogSampleType />,
  },
  {
    path: "caster-molds/*",
    sidebar: () => <div>Molds</div>,
    main: () => <CatalogMold />,
  },
  {
    path: "caster-mold-sizes/*",
    sidebar: () => <div>Mold Sizes</div>,
    main: () => <CatalogMoldSize />,
  },
  {
    path: "caster-tundishes/*",
    sidebar: () => <div>Tundishes</div>,
    main: () => <CatalogTundish />,
  },
  {
    path: "caster-tundish-shrouds/*",
    sidebar: () => <div>Tundish Shrouds</div>,
    main: () => <CatalogTundishShroud />,
  },
  {
    path: "caster-pourback-reasons/*",
    sidebar: () => <div>Pourback Reasons</div>,
    main: () => <CatalogPourbackReason />,
  },
  {
    path: "byi-cranes/*",
    sidebar: () => <div>Cranes</div>,
    main: () => <CatalogCrane />,
  },
  {
    path: "byi-locations/*",
    sidebar: () => <div>Locations</div>,
    main: () => <CatalogLocation />,
  },
  {
    path: "steel-bins/*",
    sidebar: () => <div>Bins</div>,
    main: () => <CatalogBin />,
  },
  {
    path: "steel-grades/*",
    sidebar: () => <div>grades</div>,
    main: () => <CatalogGrade />,
  },
  {
    path: "steel-grades-upload/*",
    sidebar: () => <div>Upload Grades</div>,
    main: () => <CatalogGrade />,
  },
  {
    path: "steel-ladles/*",
    sidebar: () => <div>ladles</div>,
    main: () => <CatalogLadle />,
  },
  {
    path: "steel-materials/*",
    sidebar: () => <div>materials</div>,
    main: () => <CatalogMaterial />,
  },
  {
    path: "delay-categories",
    sidebar: () => <div>Delay Categories</div>,
    main: () => <CatalogCategories />,
  },
  {
    path: "delay-codes-eaf",
    sidebar: () => <div>EAF Delay Codes</div>,
    main: () => <DelayCodePage delayAreaAssetName="EAF" />,
  },
  {
    path: "delay-codes-caster",
    sidebar: () => <div>CASTER Delay Codes</div>,
    main: () => <DelayCodePage delayAreaAssetName="CASTER" />,
  },
  {
    path: "strand-loss-reasons",
    sidebar: () => <div>Strand Losses</div>,
    main: () => (
      <DelayCodePage
        delayAreaAssetName="STRANDS"
        displayName="Strand Losses"
        variant="reason"
      />
    ),
  },
  {
    path: "operators/*",
    sidebar: () => <div>operators</div>,
    main: () => <CatalogOperator />,
  },
  {
    path: "scrap-yard/commodities/*",
    sidebar: () => <div>commodities</div>,
    main: () => <CommodityModule />,
  },
  {
    path: "scrap-yard/commodity-types/*",
    sidebar: () => <div>commodity types</div>,
    main: () => <CommodityTypeModule />,
  },
  {
    path: "scrap-charges/*",
    sidebar: () => <div>charges</div>,
    main: () => <ChargeManagement />,
  },
  {
    path: "eaf-roof-metric-limits/*",
    sidebar: () => <div>EAF Roof Metric Limits</div>,
    main: () => <CatalogRoofMetricLimits />,
  },
  {
    path: "eaf-sidewall-metric-limits/*",
    sidebar: () => <div>EAF Sidewall Metric Limits</div>,
    main: () => <CatalogSidewallMetricLimits />,
  },
  {
    path: "caster-mold-metric-limits/*",
    sidebar: () => <div>Caster Mold Metric Limits</div>,
    main: () => <CatalogCasterMetricLimits />,
  },
];

const sidebar = ({ option }: { option?: string }) => {
  const theme = useTheme();

  return (
    <>
      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            Operators
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "operators"}
          component={Link}
          to="/configuration/operators"
        >
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary="Operators" />
        </ListItemButton>
      </List>

      <Divider />

      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            EAF
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "eaf-roof-metric-limits"}
          component={Link}
          to="/configuration/eaf-roof-metric-limits"
        >
          <ListItemIcon>
            <TimelineIcon />
          </ListItemIcon>
          <ListItemText primary="Roof Metric Limits" />
        </ListItemButton>
        <ListItemButton
          selected={option === "eaf-sidewall-metric-limits"}
          component={Link}
          to="/configuration/eaf-sidewall-metric-limits"
        >
          <ListItemIcon>
            <TimelineIcon />
          </ListItemIcon>
          <ListItemText primary="Sidewall Metric Limits" />
        </ListItemButton>
      </List>

      <Divider />

      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            Scrap Yard
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "scrap-yard/commodities"}
          component={Link}
          to="/configuration/scrap-yard/commodities"
        >
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText primary="Commodities" />
        </ListItemButton>
        <ListItemButton
          selected={option === "scrap-yard/commodity-types"}
          component={Link}
          to="/configuration/scrap-yard/commodity-types"
        >
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText primary="Commodity Types" />
        </ListItemButton>
      </List>

      <Divider />

      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            Caster
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "caster-molds"}
          component={Link}
          to="/configuration/caster-molds"
        >
          <ListItemIcon>
            <StorageIcon />
          </ListItemIcon>
          <ListItemText primary="Molds" />
        </ListItemButton>
        <ListItemButton
          selected={option === "caster-mold-sizes"}
          component={Link}
          to="/configuration/caster-mold-sizes"
        >
          <ListItemIcon>
            <StorageIcon />
          </ListItemIcon>
          <ListItemText primary="Mold Sizes" />
        </ListItemButton>
        <ListItemButton
          selected={option === "caster-tundishes"}
          component={Link}
          to="/configuration/caster-tundishes"
        >
          <ListItemIcon>
            <DrinkIcon />
          </ListItemIcon>
          <ListItemText primary="Tundishes" />
        </ListItemButton>
        <ListItemButton
          selected={option === "caster-tundish-shrouds"}
          component={Link}
          to="/configuration/caster-tundish-shrouds"
        >
          <ListItemIcon>
            <DrinkIcon />
          </ListItemIcon>
          <ListItemText primary="Tundish Shrouds" />
        </ListItemButton>
        <ListItemButton
          selected={option === "caster-pourback-reasons"}
          component={Link}
          to="/configuration/caster-pourback-reasons"
        >
          <ListItemIcon>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText primary="Pourback Reasons" />
        </ListItemButton>
        <ListItemButton
          selected={option === "caster-mold-metric-limits"}
          component={Link}
          to="/configuration/caster-mold-metric-limits"
        >
          <ListItemIcon>
            <TimelineIcon />
          </ListItemIcon>
          <ListItemText primary="Mold Metric Limits" />
        </ListItemButton>
        <ListItemButton
          selected={option === "strand-loss-reasons"}
          component={Link}
          to="/configuration/strand-loss-reasons"
        >
          <ListItemIcon>
            <TimelineIcon />
          </ListItemIcon>
          <ListItemText primary="Strand Losses" />
        </ListItemButton>
      </List>

      <Divider />

      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            Billets Yard
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "byi-cranes"}
          component={Link}
          to="/configuration/byi-cranes"
        >
          <ListItemIcon>
            <ScienceIcon />
          </ListItemIcon>
          <ListItemText primary="Cranes" />
        </ListItemButton>
        <ListItemButton
          selected={option === "byi-locations"}
          component={Link}
          to="/configuration/byi-locations"
        >
          <ListItemIcon>
            <StorageIcon />
          </ListItemIcon>
          <ListItemText primary="Locations" />
        </ListItemButton>
      </List>

      <Divider />

      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            Laboratory
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "lab-elements"}
          component={Link}
          to="/configuration/lab-elements"
        >
          <ListItemIcon>
            <ScienceIcon />
          </ListItemIcon>
          <ListItemText primary="Elements" />
        </ListItemButton>
        <ListItemButton
          selected={option === "lab-sample-types"}
          component={Link}
          to="/configuration/lab-sample-types"
        >
          <ListItemIcon>
            <ScienceIcon />
          </ListItemIcon>
          <ListItemText primary="Sample Types" />
        </ListItemButton>
      </List>

      <Divider />

      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            Steel
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "steel-bins"}
          component={Link}
          to="/configuration/steel-bins"
        >
          <ListItemIcon>
            <StorageIcon />
          </ListItemIcon>
          <ListItemText primary="Bins" />
        </ListItemButton>
        <ListItemButton
          selected={option === "steel-grades"}
          component={Link}
          to="/configuration/steel-grades"
        >
          <ListItemIcon>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText primary="Grades" />
        </ListItemButton>
        <ListItemButton
          selected={option === "steel-grades-upload"}
          component={Link}
          to="/configuration/steel-grades/upload"
        >
          <ListItemIcon>
            <CloudUploadIcon />
          </ListItemIcon>
          <ListItemText primary="Upload Grades" />
        </ListItemButton>
        <ListItemButton
          selected={option === "steel-ladles"}
          component={Link}
          to="/configuration/steel-ladles"
        >
          <ListItemIcon>
            <DrinkIcon />
          </ListItemIcon>
          <ListItemText primary="Ladles" />
        </ListItemButton>
        <ListItemButton
          selected={option === "steel-materials"}
          component={Link}
          to="/configuration/steel-materials"
        >
          <ListItemIcon>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText primary="Materials" />
        </ListItemButton>
      </List>

      <Divider />

      <List
        subheader={
          <ListSubheader
            style={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
              fontWeight: 600,
            }}
          >
            Delays
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={option === "delay-categories"}
          component={Link}
          to="/configuration/delay-categories"
        >
          <ListItemIcon>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText primary="Categories" />
        </ListItemButton>
        <ListItemButton
          selected={option === "delay-codes-eaf"}
          component={Link}
          to="/configuration/delay-codes-eaf"
        >
          <ListItemIcon>
            <TimelineIcon />
          </ListItemIcon>
          <ListItemText primary="EAF Codes" />
        </ListItemButton>
        <ListItemButton
          selected={option === "delay-codes-caster"}
          component={Link}
          to="/configuration/delay-codes-caster"
        >
          <ListItemIcon>
            <TimelineIcon />
          </ListItemIcon>
          <ListItemText primary="Caster Codes" />
        </ListItemButton>
      </List>
    </>
  );
};

const customConfigurations: ConfigurationsType = [components, sidebar];

export { customConfigurations };
